import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Validators, FormGroup, FormBuilder } from "@angular/forms";
import { UserService } from "../../providers/session-service/user-service";
import { AngularFireAuth } from "angularfire2/auth";
import { HomePage } from "../home/home";
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})
export class RegisterPage {

  private registerData: FormGroup;
  showSpinner: boolean;
  team: any;
  readyToRegister: boolean;
  passwordsRef: any;

  constructor(public navCtrl: NavController, private userService: UserService,
    private formBuilder: FormBuilder, private db: AngularFirestore, private auth: AngularFireAuth) {
    this.showSpinner = false;
    this.readyToRegister = false;
    this.registerData = this.formBuilder.group({
      email: ["", Validators.email],
      name: ["", Validators.required],
      password: ["", Validators.compose([Validators.required, Validators.minLength(6)])]
    });
  }

  checkTeamCode() {
    let givenPass = this.registerData.value.password.toUpperCase();

    if (givenPass !== null && givenPass.length === 7) {
      this.passwordsRef = this.db.doc("passwords/" + givenPass).valueChanges().subscribe(password => {
        if (password === null) {
          this.team = null;
          this.readyToRegister = false;
          this.userService.createToast('Ο κωδικός δεν αντιστοιχεί σε κάποια ομάδα. Παρακαλώ εισάγετε έναν έγκυρο κωδικό.');
        } else {
          this.db.doc("teams/" + password['teamId']).valueChanges().subscribe(team => {
            this.team = team;
            this.team.id = password['teamId'];
            this.readyToRegister = true;
          });
        }
      });
    } else {
      this.team = null;
      this.readyToRegister = false;
    }
  }

  register() {
    this.showSpinner = true;

    let details = {
      'email': this.registerData.value.email,
      'password': this.registerData.value.password
    };

    this.auth.auth.createUserWithEmailAndPassword(details.email, details.password).then(userCreated => {
      let userData = {
        "id": userCreated.uid,
        "birthday": "",
        "debt": 0,
        "email": this.registerData.value.email,
        "image": "https://s3.amazonaws.com/ionic-api-auth/users-default-avatar@2x.png",
        "name": this.registerData.value.name,
        "phone": "",
        "role": this.team.id !== "staff" ? "player" : "staff",
        "teamId": this.team.id
      };

      this.db.doc('users/' + userCreated.uid).set(userData).then(() => {
        this.auth.auth.signInWithEmailAndPassword(details.email, details.password).then(() => {
          this.userService.startSession(userData);
          this.navCtrl.setRoot(HomePage);
          this.showSpinner = false;
        });
      });

      this.passwordsRef.unsubscribe();
      this.db.doc('passwords/' + details.password).delete();
    }).catch((error) => {
      if (error['code'] === 'auth/email-already-in-use') {
        this.userService.createToast('Το email που επιλέξατε χρησιμοποιείται ήδη. Παρακαλώ εισάγετε ένα διαφορετικό.');
      } else if (error['code'] === 'auth/invalid-email') {
        this.userService.createToast('Το email που επιλέξατε δεν είναι έγκυρο. Παρακαλώ εισάγετε ένα διαφορετικό.');
      }
      this.showSpinner = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts